const faqs = document.querySelectorAll(".faq-section")
faqs.forEach(faq =>{
    const faqBlocks = faq.querySelectorAll(".faq-block")
    faqBlocks.forEach(block =>block.addEventListener("click",function(){
        if(block.classList.contains("open")){
            block.classList.remove("open")
            return
        }
        faqBlocks.forEach(b => b.classList.remove("open"))
        block.classList.add("open")
    }))
})